import PostServiceApi from "../../../../../services/post-service";

const handleupdatePostRecord = async ({ fieldName, value, postId }) => {
  const data = {};
  switch (fieldName) {
    case "originCountryCode":
      data.personalInfo = {
        originCountryCode: value,
      };
      break;

    default:
      break;
  }
  try {
    const response = await PostServiceApi.updatePost({ data, postId });
    if (!response.success) {
      throw new Error("Unable to update post");
    }
    return response;
  } catch (error) {
    throw new Error();
  }
};

const PostRecordUpdateModalDomain = Object.freeze({ handleupdatePostRecord });

export default PostRecordUpdateModalDomain;
